export default __webpack_public_path__ + "static/media/ThaID2.1cc183c3.png";